<div id="content">
  <button [hidden] = '!generateAvailable' (click)="generateReport()" class = "generateButton" i18n="@@reports.generate">Generuj</button>
  <div id="subContent" [style.marginTop.px] = 'generateAvailable ? 0 : 40'>
    <div class="column">
      <h1 i18n="@@reports.type">Typ raportu:</h1>
      <mat-selection-list [multiple]="false">
        <!--mat-list-option (click)="chooseReport(reportType.PDF)">
          <div class="listOption">
            <img class="imgInfo"  [src]="report === reportType.PDF ? '/assets/pdfa.png' : '/assets/pdf.png' " height="100%" >
            <a [ngStyle]="{color: report === reportType.PDF ? 'rgb(94, 137, 250)' : 'rgb(245, 245, 245)'}">PDF</a>
          </div>
        </!--mat-list-option-->
        <mat-list-option (click)="chooseReport(reportType.CSV)">
          <div class="listOption">
            <img class="imgInfo"  [src]="report === reportType.CSV ? '/assets/csva.png' : '/assets/csv.png' " height="100%" >
            <a [ngStyle]="{color: report === reportType.CSV ? 'rgb(94, 137, 250)' : 'rgb(245, 245, 245)'}">CSV</a>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </div>
    <div class="column">
      <div class="checkAllLine" [ngStyle]="{'visibility': locationsHidden ? 'hidden' : 'visible'}">
        <h1 i18n="@@reports.warehouses">Magazyny:</h1>
        <mat-checkbox (change)="markAll($event.checked, locs, reportColum.Locations)" class="checkBoxMarker"></mat-checkbox>
      </div>
      <mat-selection-list (selectionChange)="locationsChanged($event.source.selectedOptions.selected)" #locs>
        <mat-list-option *ngFor="let tag of this.locations" [value]="tag">
          {{tag}}
        </mat-list-option>
      </mat-selection-list>
    </div>
    <div class="column">
      <div class="checkAllLine" [ngStyle]="{'visibility': markersHidden ? 'hidden' : 'visible'}">
        <h1 i18n="@@reports.markers">Znaczniki:</h1>
        <mat-checkbox (change)="markAll($event.checked, tags, reportColum.Markers)" class="checkBoxMarker"></mat-checkbox>
      </div>
      <mat-selection-list (selectionChange)="tagsChanged($event.source.selectedOptions.selected)" #tags>
        <mat-list-option *ngFor="let tag of this.markers" [value]="tag">
          {{tag}}
        </mat-list-option>
      </mat-selection-list>
    </div>
    <div class="column">
      <div class="checkAllLine" [ngStyle]="{'visibility': headersHidden ? 'hidden' : 'visible'}">
        <h1 i18n="@@reports.fields">Pola:</h1>
        <mat-checkbox (change)="markAll($event.checked, options, reportColum.Headers)" class="checkBoxMarker"></mat-checkbox>
      </div>
      <mat-selection-list (selectionChange)="headersChanged($event.source.selectedOptions.selected)" #options>
        <mat-list-option *ngFor="let header of this.headers | keyvalue" [value]="header">
          {{header.value}}
        </mat-list-option>
      </mat-selection-list>
    </div>
  </div>
</div>
